import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import {
  AvailableIcon,
  MobileIconDubai,
  BlockChain,
} from "../../../../app-constants";

const Copyright = () => {
  return (
    <div className="copyright_dubai" style={{ background: "#314252" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <div className="copyright_box">
              <ul>
                <li>Let’s Talk to Discuss Growth Opportunities</li>
                <li>
                  {AvailableIcon}
                  <Link to="/contact">we are available 24/7!</Link>
                </li>
                <li>
                  {MobileIconDubai}
                  <Link to="tel:+966115203886">+ 966115203886</Link>
                </li>
                <li>
                  {BlockChain}
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => window.Tawk_API && window.Tawk_API.toggle()}
                    className="live_chat"
                  >
                    Live Chat
                  </div>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Copyright;
